import uniqid from 'uniqid'
import GitHubIcon from '@mui/icons-material/GitHub'
import LaunchIcon from '@mui/icons-material/Launch'
import EditIcon from '@mui/icons-material/Edit'
import DescriptionIcon from '@mui/icons-material/Description'
import './ProjectContainer.css'

const ProjectContainer = ({ project }) => (
  <div className='project'>
    <h3>{project.name}</h3>

    <p className='project__description'>{project.description}</p>
    {project.stack && (
      <ul className='project__stack'>
        {project.stack.map((item) => (
          <li key={uniqid()} className='project__stack-item'>
            {item}
          </li>
        ))}
      </ul>
    )}

    {project.blog && (
      <a
        href={project.blog}
        aria-label='live preview'
        className='link link--icon'
        target='blank'
      >
        <EditIcon />
      </a>
    )}

    {project.sourceCode && (
      <a
        href={project.sourceCode}
        aria-label='source code'
        className='link link--icon'
        target='blank'
      >
        <GitHubIcon />
      </a>
    )}

    {project.livePreview && (
      <a
        href={project.livePreview}
        aria-label='live preview'
        className='link link--icon'
        target='blank'
      >
        <LaunchIcon />
      </a>
    )}

    {project.docs && (
      <a
        href={project.docs}
        aria-label='live preview'
        className='link link--icon'
        target='blank'
      >
        <DescriptionIcon />
      </a>
    )}
  </div>
)

export default ProjectContainer
